import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ActivityFeed.css';
import './ExamsFeed.css';

const ICONO = { examen: '🎓', colocacion: '🧭', onboarding: '🚀' };
const TIPO_LABEL = { examen: 'Examen de nivel', colocacion: 'Colocación', onboarding: 'Diagnóstico' };

function cuando(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString(undefined, {
      day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
    });
  } catch { return ''; }
}

/* ── CUÁNTOS SE ENSEÑAN DE ENTRADA ───────────────────────────────────────
   Rob, 27-09-2026: «el dashboard crece sin scroll».

   Y crecía de verdad: cada intento sumaba una fila, sin tope. Quien repite un
   examen cuatro veces —que es lo normal y lo que queremos— empujaba el resto
   del panel fuera de la pantalla.

   Cuatro es lo que cabe sin que la sección se coma el panel, y el resto se
   despliega a un toque. No se recorta y ya está: lo que no se ve tiene que
   poder verse, o es información que se pierde. */
const DE_ENTRADA = 4;

function ExamsFeed({ exams }) {
  const navigate = useNavigate();
  const [todos, setTodos] = useState(false);

  const lista = exams || [];
  const visibles = todos ? lista : lista.slice(0, DE_ENTRADA);
  const ocultos = lista.length - visibles.length;

  return (
    <div className="dp-activity-card dp-neumorphic">
      <h2 className="dp-section-title">Exámenes Recientes</h2>
      <div className="dp-activity-list">
        {lista.length > 0 ? (
          visibles.map((ex, i) => {
            const abrible = !!ex.session_id;
            const abrir = () => abrible && navigate(`/examenes?result=${ex.session_id}`);
            const estadoTag = ex.aprobado === true ? 'Aprobado'
              : ex.aprobado === false ? 'Reprobado'
                : (ex.estado === 'in_progress' ? 'En curso' : null);
            const tagClase = ex.aprobado === true ? 'exf-tag-ok'
              : ex.aprobado === false ? 'exf-tag-no' : 'exf-tag-neutro';
            return (
              <div
                key={i}
                className={`dp-activity-item dp-neumorphic-flat exf-item${abrible ? ' exf-clic' : ''}`}
                onClick={abrir}
                role={abrible ? 'button' : undefined}
                tabIndex={abrible ? 0 : undefined}
                onKeyDown={(e) => { if (abrible && (e.key === 'Enter' || e.key === ' ')) abrir(); }}
              >
                <div className="dp-activity-info">
                  <div className="dp-activity-icon">{ICONO[ex.tipo] || '📝'}</div>
                  <div className="dp-activity-details">
                    <div className="dp-activity-title">{ex.titulo}</div>
                    <div className="dp-activity-date">
                      {TIPO_LABEL[ex.tipo] || 'Examen'}
                      {ex.cefr ? ` · nivel ${ex.cefr}` : ''}
                      {ex.fecha ? ` · ${cuando(ex.fecha)}` : ''}
                    </div>
                    {estadoTag && <span className={`exf-tag ${tagClase}`}>{estadoTag}</span>}
                  </div>
                </div>
                <div className="exf-right">
                  <div className={`exf-score ${ex.aprobado === true ? 'exf-score-ok' : ex.aprobado === false ? 'exf-score-no' : ''}`}>
                    {ex.score != null ? `${Math.round(ex.score)}%` : (ex.cefr || '—')}
                  </div>
                  {abrible && <span className="exf-ver">Ver →</span>}
                </div>
              </div>
            );
          })
        ) : (
          <p>Aún no has presentado un examen. ¡Empieza uno desde tu curso!</p>
        )}
      </div>

      {/* Lo que no cabe, a un toque. Y se dice CUÁNTOS hay debajo: «ver más»
          sin número no dice si son dos o veinte. */}
      {ocultos > 0 && (
        <button type="button" className="exf-mas" onClick={() => setTodos(true)}>
          Ver mis {lista.length} exámenes →
        </button>
      )}
      {todos && lista.length > DE_ENTRADA && (
        <button type="button" className="exf-mas" onClick={() => setTodos(false)}>
          Ver sólo los últimos
        </button>
      )}
    </div>
  );
}

export default ExamsFeed;
